module.exports = __webpack_public_path__ + "media/images/iconbox/icon13-f0c4d81b1c21713996eb353406e6d695.png";